import Model, {
  attr,
  belongsTo,
  type AsyncBelongsTo,
} from '@warp-drive/legacy/model';
import type { Type } from '@warp-drive/core/types/symbols';
import type Group from '@linc-technologies/linced-common/models/school-options/group';

// Proto: schools.OptionHeading.
export default class Heading extends Model {
  declare [Type]: 'school-options/heading';

  @attr('string', { defaultValue: '' })
  declare name: string;

  @attr('string', { defaultValue: '' })
  declare key: string;

  @attr('number', { defaultValue: 0 })
  declare sequence: number;

  @belongsTo('school-options/group', { async: true, inverse: 'headings' })
  declare groupId: AsyncBelongsTo<Group>;
}
